import { EventBus, Events } from "jiffy-store";
import "./product-details-made-sample-cta.scss";

const $getSampleLinks = () => document.querySelectorAll(".js-made-sample-cta-link");
const $getSampleToggler = () => document.querySelector(".js-made-sample-cta-toggler");
const $getProductPageContainer = () => document.getElementById("product-page-container");

const initCollapse = () => {
  const $sampleToggler = $getSampleToggler();
  if (!$sampleToggler) return;

  $sampleToggler.addEventListener("click", () => {
    const isExpanded = $sampleToggler.ariaExpanded === "true";
    $sampleToggler.ariaExpanded = !isExpanded;
    $getProductPageContainer().classList.toggle(
      "product-details__container--sample-collapsed",
      isExpanded
    );
  });
};

const initChangeColorHandler = () => {
  EventBus.on(Events.PRODUCT_COLOR_SELECTED_FROM_SLIDER, (e, { color }) => {
    const $sampleLinks = $getSampleLinks();
    const [$sampleLink] = $sampleLinks;
    if (!$sampleLink) return;

    const url = new URL($sampleLink.href);
    url.searchParams.set("ac", color);
    $sampleLinks.forEach($link => {
      // eslint-disable-next-line no-param-reassign
      $link.href = url.pathname + url.search;
    });
  });
};

export default () => {
  initCollapse();
  initChangeColorHandler();
};
